export const ROLES = Object.freeze({
  SUPER_ADMIN: "super_admin",
  ADMIN: "admin",
  UNIT_ADMIN: "unit_admin",
  MEDICAL_RECORDS: "medical_records",
  DOCTOR: "doctor",
  NURSE: "nurse",
  LABORATORY: "laboratory",
  PHARMACY: "pharmacy",
  CASH_POINT: "cash_point",
  STAFF: "staff",
});

export const ROLE_OPTIONS = [
  [ROLES.STAFF, "Staff (basic access)"],
  [ROLES.MEDICAL_RECORDS, "Medical records"],
  [ROLES.DOCTOR, "Doctor"],
  [ROLES.NURSE, "Nurse"],
  [ROLES.LABORATORY, "Laboratory"],
  [ROLES.PHARMACY, "Pharmacy"],
  [ROLES.CASH_POINT, "Cash point"],
  [ROLES.ADMIN, "Administrator"],
  [ROLES.UNIT_ADMIN, "Unit administrator"],
  [ROLES.SUPER_ADMIN, "Super administrator"],
];
